<template>
    <v-form
        ref="loginForm"
		v-model="valid"
        class="form-box formStyle">
            <template v-if="!dataType">
            <!-- <img src="@/assets/img/border.png" alt="" style="position: absolute;left: 30px;top: 21px;"> -->
                <v-text-field
                    v-model="form.password"
                    outlined
                    required
                    :append-icon="isPwdVisible1 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    dense
                    :type="isPwdVisible1 ? 'text' : 'password'"
                    :label="$t('account.pwd')"
                    :placeholder="$t('account.pwdPlaceholder')"
                    hide-details="auto"
                    :rules="loginFormRule.password"
                    class="mb-6"
                    @click:append="isPwdVisible1 = !isPwdVisible1"
                ></v-text-field>
                <v-text-field
                    v-model="form.affirmPassword"
                    required
                    :append-icon="isPwdVisible2 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    outlined
                    dense
                    :type="isPwdVisible2 ? 'text' : 'password'"
                    :label="$t('account.login.affirmPwd')"
                    :placeholder="$t('account.login.affirmPwdPlaceholder')"
                    hide-details="auto"
                    :rules="loginFormRule.affirmPassword"
                    class="mb-6"
                    @click:append="isPwdVisible2 = !isPwdVisible2"
                ></v-text-field>
            </template>
            <template v-else>
            <!-- <img src="@/assets/img/border.png" alt="" style="position: absolute;left: 30px;top: 21px;"> -->
                <v-text-field
                    v-model="form.oldPassword"
                    outlined
                    required
                    dense
                    :append-icon="isPwdVisible3 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    :type="isPwdVisible3 ? 'text' : 'password'"
                    :label="$t('account.login.oldPwd')"
                    :placeholder="$t('account.pwdPlaceholder')"
                    hide-details="auto"
                    :rules="loginFormRule.oldPassword"
                    class="mb-6"
                    @click:append="isPwdVisible3 = !isPwdVisible3"
                ></v-text-field>
                <v-text-field
                    v-model="form.password"
                    :append-icon="isPwdVisible4 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    required
                    outlined
                    dense
                    :type="isPwdVisible4 ? 'text' : 'password'"
                    :label="$t('account.login.newPwd')"
                    :placeholder="$t('account.login.newPwdPlaceholder')"
                    hide-details="auto"
                    :rules="loginFormRule.password"
                    class="mb-6"
                    @click:append="isPwdVisible4 = !isPwdVisible4"
                ></v-text-field>
                <v-text-field
                    v-model="form.affirmPassword"
                    :append-icon="isPwdVisible5 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    required
                    outlined
                    dense
                    :type="isPwdVisible5 ? 'text' : 'password'"
                    :label="$t('account.login.affirmPwd')"
                    :placeholder="$t('account.login.affirmPwdPlaceholder')"
                    hide-details="auto"
                    :rules="loginFormRule.affirmPassword"
                    class="mb-6"
                    @click:append="isPwdVisible5 = !isPwdVisible5"
                ></v-text-field>
            </template>
            <v-row no-gutters>
                <v-col cols="12" class="mb-2">
                    <v-btn color="primary" @click="onSubmit" small>
                        {{$t('btn.submit')}}
                    </v-btn>
                    <v-btn class="close_btn" outlined @click="close" small>
                        {{$t('btn.close')}}
                    </v-btn>
                </v-col>
            </v-row>
    </v-form>
</template>

<script>
import { resetUserPwd, setUserPwd, logout } from "@/api/index";
import {IsIPMode} from '@/utils/cookie'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import store from '@/store'


export default {
    data() {
        let validatePass2 = (value) => {
            if (value === '') {
                return this.$t('account.login.affirmPwdPlaceholder');
            } else if (value !== this.form.password) {
                return this.$t('pwd.verifyPassword');
            } else {
                return true;
            }
        };
        let validatePass = (v) => {
            if(!v){
                return this.$t('account.pwdPlaceholder')
            }else if(this.$checkPassword(v)){
                return this.$checkPassword(v) == true ? undefined : this.$checkPassword(v)
            }else {
                return true
            }
        }
        return {
            form: {},
            isPwdVisible1:false,
            isPwdVisible2:false,
            isPwdVisible3:false,
            isPwdVisible4:false,
            isPwdVisible5:false,
            valid: false,
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline
            },
            loginFormRule:
                {
                    password: [
                        v => !!v || this.$t('account.pwdPlaceholder'),
                        v => validatePass(v)
                    ],
                    affirmPassword: [
                        v => !!v || this.$t('account.login.affirmPwdPlaceholder'),
                    ],
                    oldPassword: [
                        v => !!v || this.$t('account.login.oldPwdMsg'),
                    ],
                    affirmPassword: [
                        v => !!v || this.$t('account.login.affirmPwdPlaceholder'),
                        v => validatePass2(v)
                    ]
                }
            ,
        };
    },
    props: {
        dataType: Boolean
    },
    created() {
        self = this
    },
    watch: {
        'form.password': (val,old) => {
            if(val) {
                self.validatePass(val)
            }
        }
    },
    mounted() {
        this.$root.eventHub.$on('handleCancel1', ()=> {
            this.$refs.loginForm.resetValidation();
            this.$root.eventHub.$off("handleCancel1")
        })
    },
    methods: {
        onSubmit() {
                    if(this.$refs.loginForm.validate()){
                        let apiType = this.dataType ? resetUserPwd : setUserPwd
                        let params = {}
                        this.$passwordEncryption(this.form.password).then(password=> {
                            this.$passwordEncryption(this.form.oldPassword).then(oldPassword=> {
                                if (this.dataType) {
                                    params = {
                                        newPwd: password,
                                        pwd: oldPassword
                                    }
                                } else {
                                    params = {
                                        pwd: password
                                    }
                                }
                                apiType(params).then(res=> {
                                    if (res.code == this.$GLOBA.StatusOK) {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: res.message,
                                            colorType: 'success'
                                        })
                                        setTimeout(()=>{
                                            logout().then(res2=>{
                                                if (res2.code == this.$GLOBA.StatusOK) {
                                                    this.$cookieStore.delCookie("userInfo")
                                                    // localStorage.clear()
                                                    // this.$emit("onSubmit")
                                                    if(IsIPMode()) {
                                                        this.$router.push('/login?appKey='+ this.$route.query.appKey)
                                                    }else{
                                                        this.$router.push('/login')
                                                    }
                                                }
                                            })
                                        },500)
                                    }else{
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: res.message,
                                            colorType: 'error'
                                        })
                                    }
                                })
                            })
                        })
                    }else{
                        return false;
                    }
        },
        close() {
            this.$emit("close")
        },
        validatePass(rule, value, callback) {
            this.$checkPassword(value, callback)
        },
    },
};
</script>
<style lang="scss" scoped>
    ::v-deep .ant-btn-round{
        margin-right: 32px;
        width: 96px;
        height: 38px;
        border-radius: 6px;
        background: #5066e0;
        font-size: 18px;
    }
    ::v-deep .ant-modal-title{
        line-height: 29px;
        margin-left: 16px;
        font-size: 18px;
    }
    .formStyle{
        width: 70%;
        margin-left: 15%;
    }
    .close_btn{
        margin-left: 10px;
    }
    @media screen and (min-width: 320px) and (max-width: 480px){
        .close_btn{
            margin-left: 6px;
        }
        ::v-deep {
            .v-text-field.v-text-field--enclosed .v-text-field__details{
                padding: 0;
            }
        }
        .formStyle{
            width: 100%;
            margin-left: 0%;
            margin-top:10px;
        }
    }
</style>
